module.exports = __webpack_public_path__ + "img/banner-claim.6502c1f3.jpg";